import type { ReactNode } from 'react';

import { cn } from '../lib/utils';

// 16×16 chip for a keyboard shortcut glyph. Tone matches the surrounding
// surface — auto-picked when used via `<Button kbd={[...]}>`.

type Tone = 'light' | 'dark' | 'destructive';

type Props = {
  children: ReactNode;
  tone?: Tone;
  className?: string;
};

const toneStyles: Record<Tone, string> = {
  light: 'bg-primary-alpha-5 text-primary-60 ring-1 ring-inset ring-primary-alpha-10',
  dark: 'bg-white/10 text-white',
  destructive: 'bg-status-danger/10 text-status-danger',
};

export const Kbd = ({ children, tone = 'light', className }: Props) => {
  return (
    <kbd
      className={cn(
        'inline-flex size-4 items-center justify-center px-1 font-inter font-medium leading-none text-body-12 rounded-xs',
        toneStyles[tone],
        className,
      )}
    >
      {children}
    </kbd>
  );
};

export type { Props as KbdProps };
